export const BRAZIL_GEO_URL =
  'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson';

export const STATE_CODE_MAP = {
  AC: '12', AL: '27', AP: '16', AM: '13', BA: '29',
  CE: '23', DF: '53', ES: '32', GO: '52', MA: '21',
  MT: '51', MS: '50', MG: '31', PA: '15', PB: '25',
  PR: '41', PE: '26', PI: '22', RJ: '33', RN: '24',
  RS: '43', RO: '11', RR: '14', SC: '42', SP: '35',
  SE: '28', TO: '17',
};

export const STATE_LABEL_OFFSETS = {
  DF: [0.5, 0.5], SE: [1.5, 0], AL: [1.5, 0], RN: [1.5, 0.5],
  ES: [2, 0], RJ: [2, 0.5], SC: [0.5, 0.5],
};

export const PARTY_COLORS = {
  PT: '#e00', PL: '#003da5', MDB: '#f08000', PP: '#003c8f',
  'UNIÃO': '#2040a0', 'UNIÃO BRASIL': '#2040a0', PSD: '#00c040',
  PSDB: '#0040c0', PDT: '#c03030', PSB: '#ff6000',
  REPUBLICANOS: '#0060a0', PSOL: '#f0d000', PODE: '#00a050',
  NOVO: '#f06000', 'PCdoB': '#c00020', AVANTE: '#f08020',
  CIDADANIA: '#a040c0', SOLIDARIEDADE: '#f06020', PV: '#00a000',
  REDE: '#00b0a0',
};

export const STATE_NAMES = {
  AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia',
  CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
  MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais',
  PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí',
  RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul',
  RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo',
  SE: 'Sergipe', TO: 'Tocantins',
};

export const GAME_YEAR = 2025;

export const STAT_LABELS = ['Carisma', 'Influência', 'Recursos', 'Risco'];

export const formatUSD = (val) => {
  if (!val && val !== 0) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', notation: 'compact',
  }).format(val);
};

export const formatBRL = (val) => {
  if (!val && val !== 0) return 'R$ 0';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: 'BRL', notation: 'compact', maximumFractionDigits: 1,
  }).format(val);
};

export const formatNum = (val) => {
  if (!val && val !== 0) return '0';
  return new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 }).format(val);
};

export function capitalize(str) {
  if (!str) return '';
  return str.toLowerCase().replace(/(^|\s)\S/g, (l) => l.toUpperCase());
}
